/* eslint-disable spaced-comment */
/// <reference types="react-scripts" />
import Loader from "./../../../../Content/devel/images/large_loader.gif";
import "./../../../../node_modules/bootstrap/dist/css/bootstrap-reboot.min.css";
import "./../../../../node_modules/bootstrap/dist/css/bootstrap-grid.min.css";
import "./../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./../../../../node_modules/react-datetime/css/react-datetime.css";
import "ui/Js/array.js";
import "ui/Js/date.js";
import "ui/Js/number.js";
import "ui/Js/string.js";
import "ui/Js/fetch.js";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as userService from "../../models/services/userService";
import { Provider, connect } from "react-redux";
import { Route, Router, Switch, Redirect } from "react-router-dom";
import { PrivateRoute } from "./privateRoute";
import { customHistory } from "../../framework/customHistory";
import * as store from "../../framework/customStore";
import { LoginPageConnected } from "../../containers/login/loginPageConnected";
import { IAlertState, IApplicationState, IUserState, IInstallState, IBeforeInstallPromptEvent, IConfirmationState, IUpdateState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import { Dispatch } from "react";
import { Base } from "ui/Scripts/source/framework/base";
import FrontPageConnected from "../../containers/front/frontPageConnected";
import MessageListConnected from "../../containers/message/messageListConnected";
import MessageEditConnected from "../../containers/message/messageEditConnected";
import EventListConnected from "../../containers/event/eventListConnected";
import EventEditConnected from "../../containers/event/eventEditConnected";
import TaskListConnected from "../../containers/task/taskListConnected";
import TaskEditConnected from "../../containers/task/taskEditConnected";
import DocumentListConnected from "../../containers/document/documentListConnected";
import DocumentViewConnected from "../../containers/document/documentViewConnected";
import UserFurtherEducationListConnected from "../../containers/userFurtherEducation/userFurtherEducationListConnected";
import UserFurtherEducationEditViewConnected from "../../containers/userFurtherEducation/userFurtherEducationEditConnected";
import InstantMessageChannelListConnected from "../../containers/instantMessage/instantMessageChannelListConnected";
import InstantMessageChannelEditConnected from "../../containers/instantMessage/instantMessageChannelEditConnected";
import InstantMessageListConnected from "../../containers/instantMessage/instantMessageListConnected";
import CalendarTaskViewConnected from "../../containers/calendarTask/calendarTaskViewConnected";
import CalendarTaskEditConnected from "../../containers/calendarTask/calendarTaskEditConnected";
import UserIdCardViewConnected from "../../containers/userIdCard/userIdCardViewConnected";
import { Translations } from "ui/Scripts/source/models/translations";
import { Button } from "ui/Scripts/source/components/framework/button";
import { ConfirmationDialog } from "../framework/dialog";
import { NotificationManager } from "../../models/notification/notificationManager";
import { Session } from "../../models/session/session";
import { LoginResult } from "../../models/login/loginResult";
import { DialogButtonType } from "ui/Scripts/source/models/enums";
import moment from "moment";

const swMinUpdateFrequencyMin = 5;
let trackServiceWorkerInstalling: (serviceWorker: ServiceWorker) => void = null;
let checkServiceWorkerUpdate: () => void = null;
let lastCheckServiceWorkerUpdateTime = 0;

export interface IAppOwnProps {
}

export interface IAppStateProps {
    fetchCount: number,
    install: IInstallState;
    update: IUpdateState;
    alert: IAlertState;
    confirmation: IConfirmationState;
    user: IUserState;
}

export interface IAppDispatchProps {
    setInstallEvent: (event: IBeforeInstallPromptEvent) => void;
    clearInstallEvent: () => void;
    clearUpdateEvent: () => void;
    clearAlerts: () => void;
    clearSuccess: () => void;
    clearInfo: () => void;
    clearConfirmation: () => void;
}

type AppProps = IAppOwnProps & IAppStateProps & IAppDispatchProps;

export class App extends React.Component<AppProps, {}> {
    private successTimeOut: number;
    private errorTimeOut: number;

    componentDidMount(): void {
        const props = this.props;
        window.addEventListener("beforeinstallprompt", (e: IBeforeInstallPromptEvent) => {
            e.preventDefault();
            props.setInstallEvent(e);
        });
        moment.updateLocale("en", {
            week: {
                doy: 4,
                dow: 1
            }
        });
        moment.locale(appConfig.culture.replace("-US", ""));
        //console.log("[App] componentDidMount: NotificationManager.requestNotificationPermission()");
        NotificationManager.requestNotificationPermission();
        //Initialize user state from local storage if logged in and user state not initialized
        const sessionState = Session.getSessionState();
        if (!Base.isNullOrUndefined(sessionState) && !Base.isNullOrEmpty(sessionState.accessToken) && !props.user.initialized) {
            store.customStore.dispatch(storeActions.loginSuccess(new LoginResult(sessionState)));
            userService.getCultureFromDatabase()
                .then(async (culture) => {
                    appConfig.culture = culture.culture;
                    Translations.setCulture(appConfig.culture);
                    if (sessionState.culture !== culture.culture) {
                        sessionState.culture = culture.culture;
                        await Session.setSessionState(sessionState, false);
                    }
                });
        }
    }

    static getShowSuccessMessage = (props: AppProps) => {
        return !Base.isNullOrUndefined(props.alert) && !Base.isNullOrEmpty(props.alert.message);
        //Base.logTest("test");
    };

    static getShowErrorMessage = (props: AppProps) => {
        return !Base.isNullOrUndefined(props.alert) && !Base.isNullOrEmpty(props.alert.error);
    };

    handleSuccessClick = () => {
        clearTimeout(this.successTimeOut);
        this.props.clearSuccess();
    };

    handleInfoClick = () => {
        this.props.clearInfo();
    };

    handleErrorClick = () => {
        clearTimeout(this.errorTimeOut);
        this.props.clearAlerts();
    };

    handleCloseAddToHomeScreenClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.clearInstallEvent();
    };

    handleAddToHomeScreenClick = (proposalEvent: IBeforeInstallPromptEvent) => {
        const props = this.props;
        // Show the prompt
        proposalEvent.prompt();
        // Wait for the user to respond to the prompt
        proposalEvent.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === "accepted") {
                console.log("[App] User accepted the AddToHomeScreen prompt");
            } else {
                console.log("[App] User dismissed the AddToHomeScreen prompt");
            }
            props.clearInstallEvent();
        });
    };

    handleExecuteUpdateClick = (update: IUpdateState) => {
        if (update.onYes) {
            update.onYes();
        }
        this.props.clearUpdateEvent();
    };

    handleCancelUpdateClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!Base.isNullOrUndefined(this.props.update.onNo)) {
            this.props.update.onNo();
        }
        this.props.clearUpdateEvent();
    };

    render() {
        const props = this.props;
        if (checkServiceWorkerUpdate) {
            checkServiceWorkerUpdate();
        }
        const showSuccessMessage = App.getShowSuccessMessage(props);
        if (showSuccessMessage) {
            clearTimeout(this.successTimeOut);
            this.successTimeOut = window.setTimeout(() => {
                props.clearSuccess();
            }, 2500);
        }
        const showErrorMessage = App.getShowErrorMessage(props);
        if (showErrorMessage) {
            clearTimeout(this.errorTimeOut);
            this.errorTimeOut = window.setTimeout(() => {
                props.clearAlerts();
            }, 10000);
        }
        const sessionState = Session.getSessionState();
        const canUseEvents = !!sessionState?.canUseEvents;
        const canUseTasks = !!sessionState?.canUseTasks;
        const canUseMessages = !!sessionState?.canUseMessages;
        const canUseDocuments = !!sessionState?.canUseDocuments;
        const canEditOwnRecord = !!sessionState?.canEditOwnRecord;
        const canUseInstantMessages = !!sessionState?.canUseInstantMessages;
        const canUseCalendarTasks = !!sessionState?.canUseCalendarTasks;
        return (
            <div className={sessionState?.theme ?? ""}>
                {showSuccessMessage &&
                    <div className="alertContainer">
                        <div className="globalSuccess alert alert-success" role="alert" onClick={this.handleSuccessClick}>{props.alert.message}</div>
                    </div>
                }
                {!Base.isNullOrUndefined(props.alert) && !Base.isNullOrEmpty(props.alert.info) &&
                    <div className="alertContainer info">
                        <div className="globalInfo alert alert-info" role="alert" onClick={this.handleInfoClick}>{props.alert.info}</div>
                    </div>
                }
                {showErrorMessage &&
                    <div className="alertContainer">
                        <div className="globalError alert alert-danger" role="alert" onClick={this.handleErrorClick}>{props.alert.error}</div>
                    </div>
                }
                {!Base.isNullOrUndefined(props.fetchCount) && props.fetchCount > 0 &&
                    <img className="loadingImage" alt="Loading..." src={Loader} />
                }
                <Router history={customHistory}>
                    <div>
                        <Switch>
                            <Route path="/login" component={LoginPageConnected}/>
                            <Route exact path="/" render={() => (
                                <Redirect to={"/front"} />
                            )}/>
                            <PrivateRoute exact path="/front" component={FrontPageConnected}/>
                            {canUseMessages &&
                                <PrivateRoute exact path="/message" component={MessageListConnected}/>
                            }
                            {canUseMessages &&
                                <PrivateRoute exact path="/message/:messageId" component={MessageEditConnected}/>
                            }
                            {canUseEvents &&
                                <PrivateRoute exact path="/event" component={EventListConnected}/>
                            }
                            {canUseEvents &&
                                <PrivateRoute exact path="/event/:eventId" component={EventEditConnected}/>
                            }
                            {canUseTasks &&
                                <PrivateRoute exact path="/task" component={TaskListConnected}/>
                            }
                            {canUseTasks &&
                                <PrivateRoute exact path="/task/:taskId" component={TaskEditConnected}/>
                            }
                            {canUseCalendarTasks &&
                                <PrivateRoute exact path="/calendartask" component={CalendarTaskViewConnected}/>
                            }
                            {canUseCalendarTasks &&
                                <PrivateRoute exact path="/calendartask/:calendartaskId" component={CalendarTaskEditConnected}/>
                            }
                            {canUseDocuments &&
                                <PrivateRoute exact path="/document" component={DocumentListConnected}/>
                            }
                            {canUseDocuments &&
                                <PrivateRoute exact path="/document/:folderId/:companyId" component={DocumentListConnected}/>
                            }
                            {canUseDocuments &&
                                <PrivateRoute exact path="/documentversion/:documentVersionId/:companyId" component={DocumentViewConnected}/>
                            }
                            {canEditOwnRecord &&
                                <PrivateRoute exact path="/userfurthereducation" component={UserFurtherEducationListConnected}/>
                            }
                            {canEditOwnRecord &&
                                <PrivateRoute exact path="/userfurthereducation/:userFurtherEducationId" component={UserFurtherEducationEditViewConnected}/>
                            }
                            {canEditOwnRecord &&
                                <PrivateRoute exact path="/useridcard" component={UserIdCardViewConnected}/>
                            }
                            {canUseInstantMessages &&
                                <PrivateRoute exact path="/instantmessage" component={InstantMessageChannelListConnected}/>
                            }
                            {canUseInstantMessages &&
                                <PrivateRoute exact path="/instantmessage/:channelId" component={InstantMessageListConnected}/>
                            }
                            {canUseInstantMessages &&
                                <PrivateRoute exact path="/instantmessagechanneledit/:instantMessageChannelId" component={InstantMessageChannelEditConnected}/>
                            }
                            <Route>
                                <Redirect to="/" />
                            </Route>
                        </Switch>
                    </div>
                </Router>
                {props.confirmation.show &&
                    <ConfirmationDialog
                        type={props.confirmation.type}
                        title={props.confirmation.title}
                        text={!Base.isFormattedText(props.confirmation.text) ? props.confirmation.text : <div dangerouslySetInnerHTML={{ __html: Base.getFormattedText(props.confirmation.text) }}></div>}
                        onYes={props.confirmation.onYes}
                        onNo={props.confirmation.onNo}
                        onCancel={props.confirmation.onCancel}
                    />
                }
                {!!props.install && !!props.install.proposalEvent &&
                    <div className="installView" onClick={this.handleCloseAddToHomeScreenClick}>
                        <div className="installPrompt">
                            <div className="top">
                                <div className="text">{Translations.DoYouWantToAddThisApplicationToHomeScreen}</div><div className="close" title={Translations.Close} onClick={this.handleCloseAddToHomeScreenClick}>x</div>
                            </div>
                            <div className="bottom">
                                <Button
                                    classes="center"
                                    buttonType={DialogButtonType.Primary}
                                    title={Translations.AddToHomeScreen}
                                    onClick={() => this.handleAddToHomeScreenClick(props.install.proposalEvent)}
                                />
                            </div>
                        </div>
                    </div>
                }
                {!!props.update && props.update.show && (!props.install || !props.install.proposalEvent) &&
                    <div className="installView" onClick={() => this.handleExecuteUpdateClick(props.update)}>
                        <div className="installPrompt">
                            <div className="top">
                                <div className="text">{Translations.NewVersionAvailable}</div><div className="close" title={Translations.Close} onClick={() => this.handleExecuteUpdateClick(props.update)}>x</div>
                            </div>
                            <div className="bottom">
                                <Button
                                    classes="right"
                                    buttonType={DialogButtonType.Primary}
                                    title={Translations.Update}
                                    onClick={() => this.handleExecuteUpdateClick(props.update)}
                                />
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export function mapStateToProps(state: IApplicationState): IAppStateProps {
    return {
        fetchCount: state.fetchCount,
        install: state.install,
        update: state.update,
        alert: state.alert,
        confirmation: state.confirmation,
        user: state.user
    };
}

export function mapDispatchToProps(dispatch: Dispatch<any>): IAppDispatchProps {
    return {
        setInstallEvent: (event: IBeforeInstallPromptEvent) => dispatch(storeActions.setInstallProposalEvent(event)),
        clearInstallEvent: () => dispatch(storeActions.clearInstallProposalEvent()),
        clearUpdateEvent: () => dispatch(storeActions.clearUpdate()),
        clearAlerts: () => dispatch(storeActions.clearMessages()),
        clearSuccess: () => dispatch(storeActions.clearSuccessMessage()),
        clearInfo: () => dispatch(storeActions.clearInfoMessage()),
        clearConfirmation: () => dispatch(storeActions.clearConfirmation()),
    };
}

export const AppConnected = connect<IAppStateProps, IAppDispatchProps, IAppOwnProps>(mapStateToProps, mapDispatchToProps)(App);

if (!window.Promise) {
    window.Promise = Promise;
}

if ("geolocation" in navigator) {
    /* geolocation is available */
} else {
    console.log("[App] geolocation IS NOT available!");
}

//Registering service worker
if ("serviceWorker" in navigator) {
    trackServiceWorkerInstalling = (serviceWorker: ServiceWorker) => {
        serviceWorker.addEventListener("statechange", function() {
            //Update ready
            if (serviceWorker.state === "installed") {
                store.customStore.dispatch(storeActions.setUpdate(() => {
                    serviceWorker.postMessage({ action: "skipWaiting" });
                    store.customStore.dispatch(storeActions.showInfoMessage(Translations.UpdatingApplication));
                }, () => {
                }));
            }
        });
    };

    //console.log(appConfig.rootUrl + "sw.js");
    //navigator.serviceWorker.register("./sw.js").then((reg) => {
    navigator.serviceWorker.register(appConfig.rootUrl + "sw.js").then((reg) => {
        console.log("[App] Service Worker Registered");
        //Page was not loaded with controller
        if (!navigator.serviceWorker.controller) return;
        if (!reg) return;
        //There is update ready
        if (reg.waiting) {
            store.customStore.dispatch(storeActions.setUpdate(() => {
                reg.waiting.postMessage({ action: "skipWaiting" });
                store.customStore.dispatch(storeActions.showInfoMessage(Translations.UpdatingApplication));
            }, () => {
            }));
            return;
        }
        //There update in progress
        if (reg.installing) {
            trackServiceWorkerInstalling(reg.installing);
        }
        //There update is found
        reg.addEventListener("updatefound", () => {
            trackServiceWorkerInstalling(reg.installing);
        });
        //Update service worker once in 10 min
        if (reg.update) {
            setInterval(() => {
                const currentTime = (new Date()).getTime();
                const durationMin = (currentTime - lastCheckServiceWorkerUpdateTime) / (60 * 1000);
                if (durationMin < swMinUpdateFrequencyMin) return;
                lastCheckServiceWorkerUpdateTime = currentTime;
                console.log("[App] Checking Service Worker Update");
                reg.update();
            }, 1000 * 60 * 10);
        }
    });

    // This fires when the service worker controlling this page changes, eg a new worker has skipped waiting and become the new active worker.
    let swRefreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange",
        () => {
            if (swRefreshing) return;
            swRefreshing = true;
            window.location.reload();
        }
    );

    //Manually check service worker updates
    checkServiceWorkerUpdate = () => {
        if ("serviceWorker" in navigator) {
            const currentTime = (new Date()).getTime();
            const durationMin = (currentTime - lastCheckServiceWorkerUpdateTime) / (60 * 1000);
            if (durationMin < swMinUpdateFrequencyMin) return;
            lastCheckServiceWorkerUpdateTime = currentTime;
            navigator.serviceWorker.getRegistrations().then((registrations) => {
                for (const registration of registrations) {
                    console.log("[App] Checking Service Worker Update");
                    registration.update();
                }
            });
        }
    };
} else {
    console.log("[App] serviceWorker IS NOT available!");
}

const ConnectedApp = () => (
    <Provider store={store.customStore}>
        <AppConnected />
    </Provider>
);

//Set culture from cookie before app is started
userService.getCultureFromCookie()
    .then(culture => {
        appConfig.culture = culture.culture;
        Translations.setCulture(appConfig.culture);
    })
    .finally(() => {
        ReactDOM.render(<ConnectedApp/>, document.getElementById("appContent"));
    });
